enum HTTP_METHODS_ENUM {
	GET = 'GET',
	POST = 'POST',
	PUT = 'PUT',
	PATCH = 'PATCH',
	DELETE = 'DELETE',
}

export default HTTP_METHODS_ENUM;
